import { useQuery } from '@tanstack/react-query';

import { setClientIp } from '@core/api/axiosConfig';

const queryKey = ['ip-address'];

async function fetchIpAddress(): Promise<string> {
  const response = await fetch('https://api.ipify.org/?format=json');
  const data = await response.json();

  if (data.ip) setClientIp(data.ip);
  return data.ip;
}

export function useIpAddress() {
  return useQuery({
    queryKey,
    queryFn: fetchIpAddress,
    staleTime: Infinity, // IP rarely changes during a session
    retry: 1,
  });
}
